

module.constant('namedIcons', {
    'pse': 'circle',
    'amc': 'star',
    'smart': 'square',
    'pcc': 'triangle',
    'eta': 'square',
    'vista': 'circle',
    'sbtp': 'star',
    'mntr': 'square',
    'sbirt': 'triangle',
    'ld': 'star',
    'slab': 'diamond',
    'rae': 'triangle',
    'green': 'diamond',
    'dhr': 'square',
});


module.directive('svgIcon', function(namedIcons) {
    return {
        restrict: 'E',
        template: "<svg><use xlink:href='#NAME'></use></svg>",
        link: function(scope, element, attrs) {
            var name = namedIcons[attrs.name] || attrs.name;
            element.find('use').attr('xlink:href', '#' + name);
        },
    }
});